import { useQuery } from "@tanstack/react-query"
import { useMemo } from "react"
import { useAuth } from "~/features/auth/useAuth"
import type { DetailResult, DetailView } from "~/features/detail/types"
import { GetDigitalEventByIdDocument } from "~/graphql/generated/graphql"
import { useGraphQLClient } from "~/shared/api/GraphQLClientContext"
import { toEventView } from "../projections"

export const useEventDetail = (eventId: string | undefined): DetailResult => {
  const client = useGraphQLClient()
  const { status } = useAuth()

  const query = useQuery({
    queryKey: ["event", eventId],
    queryFn: () => client.request(GetDigitalEventByIdDocument, { eventId: eventId ?? "" }),
    enabled: status === "signedIn" && Boolean(eventId),
  })

  const view = useMemo<DetailView | undefined>(() => {
    const event = query.data?.digitalEventByID

    return event ? toEventView(event) : undefined
  }, [query.data?.digitalEventByID])

  return { view, isLoading: query.isLoading, isError: query.isError }
}
